import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { SLICER_KEYS } from 'types/services';

export interface UiState {
  componentHeights: Record<string, number>;
  componentPaddings: Record<string, { top: number; bottom: number }>;
}

export const initialState: UiState = {
  componentHeights: {},
  componentPaddings: {},
};

export const uiState = createSlice({
  name: SLICER_KEYS.UI_STATE,
  initialState,
  reducers: {
    setComponentHeight: (state, action: PayloadAction<{ id: string; height: number }>) => {
      state.componentHeights[action.payload.id] = action.payload.height;
    },
    removeComponentHeight: (state, action: PayloadAction<string>) => {
      delete state.componentHeights[action.payload];
    },
    setComponentPadding: (state, action: PayloadAction<{ id: string; padding: { top: number; bottom: number } }>) => {
      state.componentPaddings[action.payload.id] = action.payload.padding;
    },
  },
});

export const uiStateActions = uiState.actions;
